module.exports = __webpack_public_path__ + "img/shareWeiBo.30d8ff40.png";